import { MODAL } from '../types';

const initialState = {
  showModal: false,
};

const impersonateModeModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL.SWITCH_IMPERSONATE_MODE_MODAL:
      return {
        showModal: !state.showModal,
      };

    default:
      return state;
  }
};

export default impersonateModeModalReducer;
